import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocumentation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16.388,
	height: 14.959,
	viewBox: "0 0 16.388 14.959",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_13639",
		"data-name": "Path 13639",
		d: "M5.2,9.54l5.725-5.725a1.347,1.347,0,1,1,1.9,1.9L5.1,13.477a2.694,2.694,0,1,1-3.811-3.81L9.371,1.586A3.7,3.7,0,0,1,14.61,6.823L8.885,12.548",
		transform: "translate(0.193 0)",
		fill: "#dad9ef",
		stroke: "#618cf5",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1
	})
});
export default SvgDocumentation;
